import React from 'react';

import { ContentZonesService, LocaleService } from '@sm360/widget-commons-core-services';

import 'vdp-used/components/WarrantiesAndPolicies/WarrantiesAndPolicies.scss';

const WarrantiesAndPolicies = () => {
    const czGroupName = 'widget.vdp.used';
    const czLocation = 'widget.vdp.used.advantages.img';
    const policyWarrantyImg = ContentZonesService.getContentZone(czGroupName, czLocation).getValue() || '';
    return (
        <div className="showroom-vdp-used-policywarranty clearfix">
            {policyWarrantyImg && <img src={policyWarrantyImg} className="" alt={LocaleService.t('WARRANTIES')} />}
        </div>
    );
};

WarrantiesAndPolicies.displayName = 'WarrantiesAndPolicies';

export default WarrantiesAndPolicies;
